import create from 'utilities/zustand/create';

export const useStatsStore = create(() => ({
  fps: 0,
  drawCalls: 0,
  triangles: 0,
}));
